import React, { useEffect, useState } from 'react';
import { Card, ListGroup, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrown, faMedal, faArrowUp, faArrowDown, faMinus } from '@fortawesome/free-solid-svg-icons';
import ClassService from './classes/ClassService';
import Avatar from 'components/common/Avatar';
const LeaderboardCard = ({ data }) => {
  const [leaderboard, setLeaderboard] = useState();
  useEffect(()=>{
    ClassService.retrieveleaderboard().then(leaderboard=>{
      setLeaderboard(leaderboard);
      console.log(leaderboard);
    });
  },
  []); 
  const getRankIcon = (rank) => {
    if (rank === 1) return <FontAwesomeIcon icon={faCrown} className="text-warning" />;
    if (rank === 2 || rank === 3) return <FontAwesomeIcon icon={faMedal} className="text-secondary" />;
    return <span className="text-white-50">#{rank}</span>;
  };

  const getTrendIcon = (trend) => {
    switch (trend) {
      case 'up':
        return <FontAwesomeIcon icon={faArrowUp} className="text-success" size="sm" />;
      case 'down':
        return <FontAwesomeIcon icon={faArrowDown} className="text-danger" size="sm" />;
      default:
        return <FontAwesomeIcon icon={faMinus} className="text-white-50" size="sm" />;
    }
  };

  return (
    <Card className="h-100 border-0 shadow-sm wod-dark-card">
      <Card.Header className="bg-transparent border-bottom border-secondary">
        <h5 className="mb-0 fw-bold">Challenge Leaderboard</h5>
        <small className="text-white-50">
          {new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
        </small>
      </Card.Header>
      <Card.Body className="p-0">
        {leaderboard?.length === 0 && (
          <div className="text-center p-3 text-white-50">
            Nothing to show.
          </div>
        )}
        {leaderboard?.length > 0 && (
        <ListGroup variant="flush">
          {leaderboard?.slice(0, 8).map((member) => (
            <ListGroup.Item
              key={member.rank}
              className={`border-secondary d-flex align-items-center py-3 wod-dark-card ${
                member.isCurrentUser ? 'border-warning border-2' : ''
              }`}
              style={member.isCurrentUser ? { backgroundColor: 'rgba(255,193,7,0.1) !important' } : {}}
            >
              <div className="me-3 text-center" style={{ width: '40px' }}>
                {getRankIcon(member.rank)}
              </div>
              {member.avatar && (
                <Avatar className={'me-3 member.status'} src={member.avatar} size="xl" />
              )}
              {!member.avatar && (
              <div
                className="rounded-circle bg-secondary d-flex align-items-center justify-content-center me-3"
                style={{ width: '36px', height: '35px', minWidth: '35px' }}
              >
                <span className="fw-bold">
                  {member.name.split(' ').map(n => n[0]).join('')}
                </span>
              </div>)}
              <div className="flex-grow-1">
                <div className="fw-semibold d-flex align-items-center">
                  {member.name}
                  {member.isCurrentUser && (
                    <Badge bg="warning" text="dark" className="ms-2">You</Badge>
                  )}
                </div>
                <small className="text-white-50">{member.score} classes</small>
              </div>
              <div className="ms-2">
                {getTrendIcon(member.trend)}
              </div>
            </ListGroup.Item>
          ))}
        </ListGroup>)}
      </Card.Body>
    </Card>
  );
};

export default LeaderboardCard;
